"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingCorePaymentStatusEnum = void 0;
var BillingCorePaymentStatusEnum;
(function (BillingCorePaymentStatusEnum) {
  /**
   * Новый
   */
  BillingCorePaymentStatusEnum["NEW"] = "NEW";
  /**
   * Платёжное намерение. Можно переходить к оплате.
   */
  BillingCorePaymentStatusEnum["INTENT"] = "INTENT";
  /**
   * Оплачен
   */
  BillingCorePaymentStatusEnum["SUCCEEDED"] = "SUCCEEDED";
  /**
   * Ошибка оплаты
   */
  BillingCorePaymentStatusEnum["FAILED"] = "FAILED";
})(BillingCorePaymentStatusEnum = exports.BillingCorePaymentStatusEnum || (exports.BillingCorePaymentStatusEnum = {}));
